<template>
  <div>
    <SkeletonScaffold
      animTimingFunction="ease-in-out"
      animDuration="3s"
      primary="#e8e8e8"
      structure="1120333304"
      borderRadius="12px"
      animDisable
    >
      <!-- Heading -->
      <div v-mBox v-mDark style="height: 1.5em;"></div>
      <br />
      <!-- Heading -->
      <div v-mBox style="height: 1.3em; width: 60%"></div>
      <!-- Sub-Heading -->
      <br />
      <!-- Content Boxes -->
      <div v-mBox v-mLight v-mRandomWidth></div>
      <br />
      <!-- Default Rectangular Button -->
      <div v-mButton></div>
    </SkeletonScaffold>
  </div>
</template>

<script>
export default {
  name: "Skelton",
  props: {},
  methods: {},
};
</script>
